import { CatalogState } from './types'

export const initialState: CatalogState = {
  batteries: [],
  filters: {},
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 0
  },
  listLoading: false,
  listError: null,
  
  batteryCache: {},
  batteryLoading: false,
  batteryError: null,
  currentBatteryId: null,
  
  featuredBatteries: [],
  featuredLoading: false,
  featuredError: null,
  
  searchResults: [],
  searchSuggestions: [],
  searchLoading: false,
  searchError: null
}

